<ng-container *transloco="let t">
<ng-template #borrowerCharacteristics>
  @if (isLoading) {
    <div class="text-center">
      <i class="fas fa-circle-notch fa-4x fa-spin"></i>
    </div>
  }

  @if (!isLoading && categories.length) {
    <div class="card shadow-sm mb-5">
      <div class="card-header">
          <h3 class="card-title">{{mainBorrower.firstName + " " + mainBorrower.lastName}}</h3>
      </div>
      <div class="card-body">
        <characteristics-per-borrower
          #characteristics
          [borrowerId]="mainBorrowerId"
          [categories]="categories"
          [applicationId]="applicationId"
          [characteristics]="getCharacteristics(mainBorrowerId)">
        </characteristics-per-borrower>
      </div>
    </div>

    @if (!inCoApplyFlow) {
      @for (borrower of otherBorrowersOnLoan; track borrower.borrowerId) {
        @if (borrowerSetting(borrower)) {
          <div class="card shadow-sm mb-5" >
              <div class="card-header">
                <h3 class="card-title">{{borrower.borrowerName}}</h3>
              </div>
              <div class="card-body">
                <characteristics-per-borrower
                  #characteristics
                  [borrowerId]="borrower.borrowerId"
                  [categories]="categories"
                  [applicationId]="applicationId"
                  [characteristics]="getCharacteristics(borrower.borrowerId)">
                </characteristics-per-borrower>
              </div>
          </div>
        }
      }
    }
  }

</ng-template>

<wizard-step-template [stepMainTemplate]="borrowerCharacteristics" [step]="step" [stepComponent]="this"></wizard-step-template>
</ng-container>
